import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { StewardNotificationDashboard } from '../components/StewardNotificationDashboard';
import StewardBottomNavigation from '../components/StewardBottomNavigation';

const StewardNotificationPage: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [vendorId, setVendorId] = useState<number | null>(null);

  useEffect(() => {
    // Check authentication and role
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    // Check if user is a steward
    const roles = (user as any)?.roles || [];
    const isSteward = roles.some((role: any) =>
      role.name === 'ROLE_STEWARD' || role === 'ROLE_STEWARD'
    );

    if (!isSteward) {
      navigate('/login');
      return;
    }

    // Get vendor ID from user object
    const userVendorId = (user as any)?.vendorId || (user as any)?.vendor?.id;
    if (userVendorId) {
      setVendorId(Number(userVendorId));
    }

    setLoading(false);
  }, [user, isAuthenticated, navigate]);

  // Timeout fallback — redirect to login if auth check hangs
  useEffect(() => {
    if (!loading) return;
    const timeout = setTimeout(() => {
      if (loading) navigate('/login');
    }, 10000);
    return () => clearTimeout(timeout);
  }, [loading, navigate]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!vendorId) {
    return (
      <Container>
        <Box mt={4}>
          <Alert severity="error">
            Unable to determine vendor. Please contact your administrator.
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ pb: 10 }}>
      <StewardNotificationDashboard vendorId={vendorId} />
      <StewardBottomNavigation />
    </Box>
  );
};

export default StewardNotificationPage;